import { BAILocale } from '.';
import id_ID from 'antd/es/locale/id_ID';

const localeValue: BAILocale = {
  lang: 'id',
  antdLocale: id_ID,
};

export default localeValue;
